import Vue from 'vue'
import Vuex from 'vuex'
import * as actions from './actions'
import * as getters from './getters'
import * as types from './mutation-types'

import login from './modules/login'
import dashboard from './modules/dashboard'
import appGlobal from './modules/app-global.js'
import quotes from './modules/quotes'
import wizard from './modules/wizard'
import notifications from './modules/notifications'
import restrictions from './modules/restrictions'
import callcodes from './modules/callcodes'
import users from './modules/users'
import dispositions from './modules/dispositions'
import statelaws from './modules/statelaws'
import zipcodes from './modules/zipcodes'
import thirdparty from './modules/thirdparty'
import logger from './modules/logger'

//components
import createLogger from '../utils/logger'
import createPersistedState from 'vuex-persistedstate'

Vue.use(Vuex)

const paths = [
  'login',
  'app.appGlobal',
  'dashboard',
  'admin_quotes.quotes',
  'wizard.wizard',
  'notifications',
  'restrictions',
  'callcodes',
  'users',
  'dispositions',
  'statelaws',
  'zipcodes',
  'thirdparty'
];

const store = new Vuex.Store({
  actions,
  getters,
  modules: {
    login,
    app: appGlobal,
    dashboard,
    admin_quotes: quotes,
    wizard: wizard,
    notifications,
    restrictions,
    callcodes,
    users,
    dispositions,
    statelaws,
    zipcodes,
    thirdparty,
    logger
  },
  mutations: {
    [types.SET_LAST_NAVIGATION](state, data) {
      state.app.lastNavigation = data
    }
  },
  plugins: process.env.NODE_ENV !== 'production' ? [createLogger(), createPersistedState({paths: paths})] : [createPersistedState({paths: paths})]
})

export default store



// WEBPACK FOOTER //
// ./src/store/index.js